import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthProvider';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';


const Background = styled('div')({
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'linear-gradient(135deg, #0059b2 0%, #009e60 100%)',
  padding: '1rem',
});

const LoginCard = styled(Card)({
  width: '100%',
  maxWidth: 420,
  borderRadius: 20,
  boxShadow: '0px 8px 25px rgba(0,0,0,0.15)',
  textAlign: 'center',
});

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const canSubmit = username.trim() !== '' && password.trim() !== '';
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      await login(username, password); // ✅ usa contexto
      // redirect é feito dentro do AuthProvider
    } catch (error: any) {
      setMessage(error.response?.data?.message || 'Usuário ou senha incorretos');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <Background>
      <LoginCard>
        <CardContent>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Box
              component="img"
              src="/images/logo_nimo_energia_quadrada.png"
              alt="Nimo Energia"
              mt={3}
              sx={{ height: { xs: 50, sm: 60 }, objectFit: 'contain' }}
            />
            <Typography variant="h5" fontWeight="bold" mb={1} mt={3}>
              Sistema de Check-in de Motoristas
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={3}>
              Faça login para acessar o painel de gerenciamento
            </Typography>

            <Box
              component="form"
              onSubmit={handleLogin}
              width="95%"
              display="flex"
              flexDirection="column"
              gap={2}
            >
              <TextField
                label="Usuário"
                variant="outlined"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value.toUpperCase())}
              />
              <TextField
                label="Senha"
                type="password"
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              {message && <Alert severity="error">{message}</Alert>}

            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                mt: 1,
                mb: 3,
                py: 1.2,
                borderRadius: 2,
                fontWeight: 'bold',
                backgroundColor: '#007b5f',
                '&:hover': { backgroundColor: '#00694f' },
              }}
              disabled={loading || !canSubmit} // ← aqui
            >
              {loading ? <CircularProgress size={26} color="inherit" /> : 'Entrar'}
            </Button>

            </Box>
          </Box>
        </CardContent>
      </LoginCard>
    </Background>
  );
};

export default LoginPage;
